// Generated by IcedCoffeeScript 1.7.1-c
(function() {
  exports.Generator = require('../lib/generator').Generator;

}).call(this);



//////////////////
// WEBPACK FOOTER
// ./node_modules/more-entropy/lib/main.js
// module id = 148
// module chunks = 0